<h1 mat-dialog-title class="p-2 text-center">Ajout d'une tâche</h1>
<div mat-dialog-content class="p-3">
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Choisir une tâche</mat-label>
            <mat-select placeholder="Choisir une tâche" [(ngModel)]="SelectedGlobalTask" (selectionChange)="setTask()" required>
                @for (t of GlobalTaskList; track t) {
                <mat-option [value]="t">
                    <span>{{t.Description}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    @if (SelectedGlobalTask && SelectedGlobalTask.Description === 'AJOUTER') {
    <div class="row justify-content-center">
        <mat-form-field class="col-12">
            <mat-label>Description de la tâche</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" [(ngModel)]="NewTaskDescription" placeholder="Description de la tâche"></textarea>
        </mat-form-field>
        <button appPreventDoubleClick class="col-auto me-1" color="primary" mat-raised-button (throttledClick)="SelectedGlobalTask = undefined">
            Retour
        </button>
        <button appPreventDoubleClick class="col-auto ms-1" color="primary" mat-raised-button (throttledClick)="addNewTask()" [disabled]="NewTaskDescription.length === 0">
            Ajouter
        </button>
    </div>
    }

    @if (SelectedGlobalTask && SelectedGlobalTask.Description !== 'AJOUTER') {
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Description</mat-label>
            <input matInput [(ngModel)]="Model.Description" placeholder="Description">
        </mat-form-field>
    </div>
    }

    @if (SelectedGlobalTask && SelectedGlobalTask.Description !== 'AJOUTER') {
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Position</mat-label>
            <input matInput [(ngModel)]="Model.Position" placeholder="Position" disabled>
        </mat-form-field>
    </div>
    }
    @if (SelectedGlobalTask && SelectedGlobalTask.Description !== 'AJOUTER') {
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Début</mat-label>
            <input matInput placeholder="Début" [matDatepicker]="picker1" [(ngModel)]="Debut" (click)="picker1.open()" (dateChange)="debutChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col">
            <mat-label>Heure</mat-label>
            <input matInput [ngxTimepicker]="timepicker1" [value]="formatTime(Debut)" [format]="24" readonly>
            <ngx-material-timepicker #timepicker1 (timeSet)="timeSetDebut($event)"></ngx-material-timepicker>
        </mat-form-field>
    </div>
    }
    @if (SelectedGlobalTask && SelectedGlobalTask.Description !== 'AJOUTER') {
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Fin</mat-label>
            <input matInput placeholder="Fin" [matDatepicker]="picker2" [(ngModel)]="Fin" (click)="picker2.open()" (dateChange)="finChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col">
            <mat-label>Heure</mat-label>
            <input matInput [ngxTimepicker]="timepicker2" [value]="formatTime(Fin)" [format]="24" readonly>
            <ngx-material-timepicker #timepicker2 (timeSet)="timeSetFin($event)"></ngx-material-timepicker>
        </mat-form-field>
    </div>
    }
    @if (SelectedGlobalTask && SelectedGlobalTask.Description !== 'AJOUTER') {
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Posture de la première tâche</mat-label>
            <mat-select placeholder="Posture de la première tâche" [(ngModel)]="Model.Posture" required>
                @for (p of PostureList; track p; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{p}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    }

    @if (SelectedGlobalTask && SelectedGlobalTask.Description !== 'AJOUTER') {
    <mat-slide-toggle class="m-1" [(ngModel)]="Model.Repetitif">Repetitif</mat-slide-toggle>
    }
    @if (SelectedGlobalTask?.Description !== 'AJOUTER') {
    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!canSave()">
            Valider
        </button>
    </div>
    }
</div>